import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";

/**
 * Gives a task's time back — the task stays, its `ScheduleEntry` goes. This is the only way to
 * unschedule: `PATCH /tasks/:id` cannot express it, because omitting the schedule fields means
 * "leave them alone", not "remove them".
 *
 * The API also clears `seriesId` here: an occurrence without a timestamp has no position in its
 * series, so unscheduling detaches.
 */
export function useUnscheduleTask(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => taskApi.unschedule(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
